import * as React from "react";
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 6, viewBox: "0 0 10 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 1L5 5L1 1", stroke: "#4D5672", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgDropdown;
